import { useAppDispatch, useAppSelector } from "../../app/store/hooks";
import { updateToastMap } from "./slice";
import { IToast } from "./definitions";
import _ from "lodash";

export const useNotifications = () => {
    const dispatch = useAppDispatch();
    const selector = useAppSelector(state => state.notifications);

    return {
        notifications: selector,
        addToast: (payload: Partial<IToast>) =>
            dispatch(handleToastMapUpdate(payload, selector.toastMap, dispatch)),
        dismissToast: (payload: string) =>
            dispatch(handleRemoveToastItem(payload, selector.toastMap, dispatch)),
    };
};

export const handleToastMapUpdate = (payload, toastMap, dispatch) => {
    const toastId = _.uniqueId(payload.id || "");
    const state: Map<string, any> = new Map(toastMap);
    state.set(toastId, { id: toastId, ...payload });

    return () => {
        dispatch(updateToastMap(state));
    };
};

const handleRemoveToastItem = (payload, toastMap, dispatch) => {
    const state: Map<string, any> = new Map(toastMap);
    state.has(payload) && state.delete(payload);

    return () => {
        dispatch(updateToastMap(state));
    };
};
